import React, { useState, ReactElement } from "react";
import { TextField, Button, Grid, Container, Typography, Card, CardActionArea, CardMedia, CardContent, Box, Tab, Tabs } from "@mui/material";
import { OptionData, RagDadChildComponentWrapper, RagDadContainer, RagDadOptionsWrapper } from './ragdad.styled';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import UploadIcon from '@mui/icons-material/Upload';
import SearchIcon from '@mui/icons-material/Search';
import QueryStats from '@mui/icons-material/QueryStats';
import Group from '@mui/icons-material/Group';
import People from '@mui/icons-material/People';
import Psychology from '@mui/icons-material/Psychology';
import UploadFile from "./actions/uploadFile";
import CreateDocument from "./actions/createDocument";
import DeleteIndex from "./actions/deleteIndex";
import SearchDocuments from "./actions/searchDocuments";
import FetchIndecies from "./actions/indicies/indicies";

function RagDad() {
    const [tabValue, setTabValue] = useState(0);

    // Handle tab change
    const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    // Get current component based on tab value
    const getCurrentComponent = () => {
        switch (tabValue) {
            case 0: return <UploadFile />;
            case 1: return <CreateDocument />;
            case 2: return <DeleteIndex />;
            case 3: return <SearchDocuments />;
            case 4: return <FetchIndecies />;
            case 5: return <DeleteIndex />;
            default: return <UploadFile />;
        }
    };

    // Define tab items with their properties
    const tabItems = [
        { label: "Upload File", icon: <UploadIcon /> },
        { label: "Create Document", icon: <AddIcon /> },
        { label: "Delete Document", icon: <DeleteIcon /> },
        { label: "Search Document", icon: <SearchIcon /> },
        { label: "Fetch Indices", icon: <SearchIcon /> },
        { label: "Delete Index", icon: <DeleteIcon /> },
    ];

    return (
        <RagDadContainer className={"p-3"}>
            <RagDadOptionsWrapper>
                <Box className="flex-1 px-2 justify-content-between">
                    <Tabs 
                        value={tabValue} 
                        onChange={handleTabChange} 
                        scrollButtons="auto"
                        className="flex-1 mb-3 justify-content-between"
                    >
                        {tabItems.map((item, index) => (
                            <Tab 
                                key={index}
                                label={item.label} 
                                icon={item.icon}
                                iconPosition="start"
                            />
                        ))}
                    </Tabs>
                </Box>
            </RagDadOptionsWrapper>
            <RagDadChildComponentWrapper>
                {getCurrentComponent()}
            </RagDadChildComponentWrapper>
        </RagDadContainer>
    );
}

export default RagDad;